module.exports = __webpack_public_path__ + "static/media/20b-05_ST-2020-44x44cm-oleo-sobre-madera.1cc6274b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20b/20b-05_ST-2020-44x44cm-oleo-sobre-madera.jpg
// module id = 250
// module chunks = 0